export default {
    async beforeMount () {
        await this.$store.dispatch('tenant/load');
    }
};
